import { Link } from 'react-router-dom';
import { useLingui } from '@lingui/react';
import { Trans } from '@lingui/macro';

import logoDark from '../images/logo-dark.png';

export default function MainAppBar(props) {
    const { sticky = false } = props;

    const { i18n } = useLingui();

    const handleLocaleChange = (locale) => {
        i18n.activate(locale);
        localStorage.setItem('store_lang', locale);
    };

    return (
        <header
            className={`${sticky ? 'sticky top-0 z-40 ' : ''}w-full border-b border-solid border-[rgb(38,43,49)]`}
            style={{
                backgroundColor: 'rgba(14, 18, 21, 0.8)',
            }}
        >
            <div className="flex items-center justify-between w-full max-w-screen-xl mx-auto px-6 sm:px-8 lg:px-10 py-4">
                <a href="https://frontdoorplus.com" className="shrink-0">
                    <img src={logoDark} alt="" className="h-8 w-auto" />
                </a>

                <nav className="flex items-center gap-6">
                    <div className="hidden sm:flex items-center gap-6">
                        <Link
                            to="/"
                            className="text-white/95 text-sm font-medium no-underline hover:text-primary transition-colors whitespace-nowrap"
                        >
                            <Trans>Upcoming Events</Trans>
                        </Link>
                        <a
                            href="https://frontdoorplus.com/help/"
                            className="text-white/95 text-sm font-medium no-underline hover:text-primary transition-colors whitespace-nowrap"
                        >
                            <Trans>Support</Trans>
                        </a>
                        <Link
                            to="/tickets"
                            className="text-primary text-sm font-medium no-underline hover:text-primary transition-colors whitespace-nowrap"
                        >
                            <Trans>Find My Tickets</Trans>
                        </Link>
                    </div>

                    <div className="flex items-center shrink-0">
                        <button
                            onClick={() => handleLocaleChange('en')}
                            className={`rounded-sm text-sm cursor-pointer bg-transparent border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
                                i18n.locale === 'en'
                                    ? 'text-white font-semibold'
                                    : 'text-[#ccc] font-normal'
                            } hover:text-[#ccc] transition-colors`}
                        >
                            EN
                        </button>
                        <span className="text-[#ccc] mx-1">|</span>
                        <button
                            onClick={() => handleLocaleChange('fr')}
                            className={`rounded-sm text-sm cursor-pointer bg-transparent border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
                                i18n.locale === 'fr'
                                    ? 'text-white font-semibold'
                                    : 'text-[#ccc] font-normal'
                            } hover:text-[#ccc] transition-colors`}
                        >
                            FR
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
}
